@if (data.title) {
  <h1 matDialogTitle>{{ data.title | translate }}</h1>
}
<mat-dialog-content class="mb-3">
  <p class="my-0 mat-body">
    {{
      data.message.expression
        | translate
          : data.message.params
          : rawMessageFallback(data.message.expression)
    }}
  </p>
  @if (data.details?.length) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'GNR_DETAILS' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>
      <mat-list dense>
        @for (message of data.details; track message; let isLast = $last) {
          <mat-list-item>{{
            message.expression
              | translate
                : message.params
                : rawMessageFallback(message.expression)
          }}</mat-list-item>
          @if (!isLast) {
            <mat-divider></mat-divider>
          }
        }
      </mat-list>
    </mat-expansion-panel>
  }
</mat-dialog-content>
<mat-dialog-actions fxLayout fxLayoutAlign="end">
  <button mat-button matDialogClose>{{ data.closeButton | translate }}</button>
</mat-dialog-actions>
